import type { ReactElement } from 'react';
import { Space, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import type { RoleRow } from './interfaces';

/** A component rather than a call to the global instance, so the label follows the language. */
const DeprecatedTag = (): ReactElement => {
  const { t } = useTranslation();

  return <Tag color="orange">{t('config.roles.deprecated')}</Tag>;
};

/** The name, plus the mark that the application no longer grants this role. */
export const renderRole = (role: string, record: RoleRow): ReactElement => (
  <Space size={[4, 4]} wrap>
    <span>{role}</span>
    {record.deprecated && <DeprecatedTag />}
  </Space>
);
